module.exports = __webpack_public_path__ + "static/media/hot.2a3f63bc.gif";


//////////////////
// WEBPACK FOOTER
// ./src/components/weather/images/hot.gif
// module id = 480
// module chunks = 0